import styled from 'styled-components'

export const ContainerTable = styled.div`
    width: 100%;
    padding: .5rem;
`
